import React from 'react'

const IconCheck = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="24" viewBox="0 -2 3 21" fill="none">
      <circle cx="8.5" cy="8.5" r="8.5" fill="#005BD3" />
      <path
        d="M6.75 9.95L5.3 8.5L4.5 9.3L6.75 11.55L12.5 5.8L11.7 5L6.75 9.95Z"
        fill="white"
      />
    </svg>
  )
}

export default IconCheck
